import { useState } from "react";
import { getLessonsForGroup, getLessonsFromLocalStorage, saveLessonsToLocalStorage } from '../utils/lessonsService';

export function useGroupUpcomingLessons({ groupId, setGroupData, setStudentLessons, updateUpcomingLessons }) {
  const [weekOffset, setWeekOffset] = useState(0);
  const [selectedDayIndex, setSelectedDayIndex] = useState(null); // mobile day-strip selection

  // Функция для изменения статуса урока
  const handleLessonStatusChange = (lessonId, newStatus) => {
    // Обновляем в основном хранилище
    const allLessonsData = getLessonsFromLocalStorage();
    const updatedLessonsData = allLessonsData.map(lesson =>
      lesson.id === lessonId ? { ...lesson, status: newStatus } : lesson
    );
    saveLessonsToLocalStorage(updatedLessonsData);

    // Обновляем состояние компонента
    setGroupData(prev => ({ ...prev }));

    // Принудительно обновляем список уроков после изменения статуса
    setTimeout(() => {
      getLessonsForGroup(groupId).then(lessons => {
        setStudentLessons(lessons);
        updateUpcomingLessons(); // Обновляем upcoming lessons
      }).catch(error => {
        console.error('Error loading lessons:', error);
      });
    }, 100);
  };

  return {
    weekOffset, setWeekOffset,
    selectedDayIndex, setSelectedDayIndex,
    handleLessonStatusChange,
  };
}
